import { TReportWebUsageReq } from "@sharedTypes/req.type";
import { TReportWebUsageRes } from "@sharedTypes/res.type";

import missingParametersError from "api/Error";
import axios from "axios";

export async function ReportWebUsage(path: string) {
  const apiUrl = "/webusage/ReportWebUsage";

  const body: TReportWebUsageReq = {
    path,
  };

  for (const [key, param] of Object.entries(body)) {
    if (param === undefined) throw missingParametersError(key);
  }

  const data: TReportWebUsageRes = await axios
    .post(apiUrl, body)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });
  return data;
}
